import { render, staticRenderFns } from "./job_list.vue?vue&type=template&id=685b6768&"
import script from "./job_list.vue?vue&type=script&lang=js&"
export * from "./job_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports